import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkOperationsToolbar = ({ 
  selectedShifts, 
  onBulkBook, 
  onBulkCancel, 
  onBulkAvailability,
  onClearSelection 
}) => {
  const [bulkAction, setBulkAction] = useState('');
  const [availabilitySettings, setAvailabilitySettings] = useState({
    timeSlot: '',
    dateRange: ''
  });

  const bulkActionOptions = [
    { value: 'book', label: 'Ausgewählte Schichten buchen' },
    { value: 'cancel', label: 'Ausgewählte Schichten stornieren' },
    { value: 'availability', label: 'Verfügbarkeit für Zeitraum setzen' }
  ];

  const timeSlotOptions = [
    { value: 'morning', label: 'Morgen (06:00-14:00)' },
    { value: 'afternoon', label: 'Nachmittag (14:00-22:00)' },
    { value: 'night', label: 'Nacht (22:00-06:00)' },
    { value: 'full', label: 'Ganztags (06:00-22:00)' }
  ];

  const dateRangeOptions = [
    { value: 'week', label: 'Diese Woche' },
    { value: 'month', label: 'Dieser Monat' },
    { value: 'quarter', label: 'Dieses Quartal' }
  ];

  const handleExecuteBulkAction = () => {
    switch (bulkAction) {
      case 'book':
        onBulkBook(selectedShifts);
        break;
      case 'cancel':
        onBulkCancel(selectedShifts);
        break;
      case 'availability':
        onBulkAvailability(availabilitySettings);
        break;
      default:
        break;
    }
    setBulkAction('');
    setAvailabilitySettings({ timeSlot: '', dateRange: '' });
  };

  const canExecuteAction = () => {
    if (bulkAction === 'availability') {
      return availabilitySettings?.timeSlot && availabilitySettings?.dateRange;
    }
    return selectedShifts?.length > 0 && bulkAction;
  };

  if (selectedShifts?.length === 0) {
    return null;
  }

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-4">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="flex items-center space-x-2">
            <Icon name="CheckSquare" size={20} className="text-primary" />
            <span className="text-sm font-medium text-foreground">
              {selectedShifts?.length} Schicht{selectedShifts?.length !== 1 ? 'en' : ''} ausgewählt
            </span>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearSelection}
            iconName="X"
            iconSize={14}
          >
            Auswahl aufheben
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <Select
          label="Aktion"
          options={bulkActionOptions}
          value={bulkAction}
          onChange={setBulkAction}
          placeholder="Aktion wählen"
        />

        {bulkAction === 'availability' && (
          <>
            <Select
              label="Zeitraum"
              options={timeSlotOptions}
              value={availabilitySettings?.timeSlot}
              onChange={(value) => setAvailabilitySettings(prev => ({ ...prev, timeSlot: value }))}
              placeholder="Zeitraum wählen"
            />

            <Select
              label="Datumsbereich"
              options={dateRangeOptions}
              value={availabilitySettings?.dateRange}
              onChange={(value) => setAvailabilitySettings(prev => ({ ...prev, dateRange: value }))}
              placeholder="Bereich wählen"
            />
          </>
        )}

        <div className="flex items-end">
          <Button
            variant="default"
            onClick={handleExecuteBulkAction}
            disabled={!canExecuteAction()}
            iconName="Play"
            iconPosition="left"
            iconSize={16}
            className="w-full"
          >
            Ausführen
          </Button>
        </div>
      </div>
      {/* Quick Actions */}
      <div className="flex items-center space-x-2 mt-4 pt-4 border-t border-border">
        <span className="text-sm text-muted-foreground">Schnellaktionen:</span>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onBulkBook(selectedShifts?.filter(s => s?.status === 'available'))}
          disabled={selectedShifts?.filter(s => s?.status === 'available')?.length === 0}
          iconName="Plus"
          iconSize={14}
        >
          Verfügbare buchen
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onBulkCancel(selectedShifts?.filter(s => s?.status === 'assigned'))}
          disabled={selectedShifts?.filter(s => s?.status === 'assigned')?.length === 0}
          iconName="X"
          iconSize={14}
        >
          Zugewiesene stornieren
        </Button>
      </div>
    </div>
  );
};

export default BulkOperationsToolbar;